export interface IApiErroPadrao {
    message?: string;
    status?: number;
    requestId?: string;
    details?: string;
    path?: string;
    timestamp?: string;
}

/**
 * Só um status HTTP de erro caracteriza o payload padrão. DTOs de negócio usam `status`
 * com outro sentido (ex.: TemaAM.status = 'Ativo') e não podem virar mensagem de erro.
 */
export const statusIndicaErroApi = (status: any): boolean => {
    const numero = typeof status === 'number'
        ? status
        : (typeof status === 'string' && status.trim() !== '' ? Number(status) : NaN);

    return Number.isFinite(numero) && numero >= 400 && numero <= 599;
};

export const isApiErroPadrao = (value: any): value is IApiErroPadrao => {
    if (!value || typeof value !== 'object') {
        return false;
    }

    const possuiMarcadorPadrao =
        value.requestId !== undefined
        || statusIndicaErroApi(value.status)
        || value.details !== undefined
        || value.path !== undefined
        || value.timestamp !== undefined;

    if (!possuiMarcadorPadrao) {
        return false;
    }

    if (value.response !== undefined || value.config !== undefined || value.isAxiosError === true) {
        return false;
    }

    return (value.message === undefined || value.message === null || typeof value.message === 'string')
        && (value.status === undefined || value.status === null || typeof value.status === 'number' || typeof value.status === 'string')
        && (value.requestId === undefined || value.requestId === null || typeof value.requestId === 'string')
        && (value.details === undefined || value.details === null || typeof value.details === 'string')
        && (value.path === undefined || value.path === null || typeof value.path === 'string')
        && (value.timestamp === undefined || value.timestamp === null || typeof value.timestamp === 'string');
};
